<template>
    <v-app>
            <div
                    id="urochat_app"
                    v-bind:class="'chat-app chat-app_'+site+' lang_'+lang"
            >
                <Chat />
            </div>
    </v-app>
</template>

<script>
    import Chat from "./components/Chat";
    import config from "./config";

    export default {
        components: {Chat},
        name: 'App',
        data() {
            return {
                site: this.$settings.site || config.SITE,
                lang: this.$settings.lang || config.LANG
            }
        }
    };
</script>

<style scoped>
    @import 'assets/css/style.css';
</style>
